import { ReactElement, useState } from 'react'
import DevelopusInputText from '../../input/DevelopusInputText'
import { withDebounce } from '../../../utils/utils'

const DevelopusInputTextTest = (): ReactElement => {
  const placeholder1 = 'Student Name 1'
  const placeholder2 = 'Student Name 2'
  const placeholder3 = 'Student Name 3'

  const [student1, setStudent1] = useState<string>('')
  const [student2, setStudent2] = useState<string>('')
  const [student3, setStudent3] = useState<string>('')

  const studentHandler1 = (text: string) => {
    console.log('1: ' + text)
    setStudent1(text)
  }

  const studentHandler2 = (text: string) => {
    console.log('2: ' + text)
    setStudent2(text)
  }

  const studentHandler3 = (text: string) => {
    console.log('3: ' + text)
    setStudent3(text)
  }

  const debouncedHandleChange1 = withDebounce(studentHandler1, 300)
  const debouncedHandleChange2 = withDebounce(studentHandler2, 300)
  const debouncedHandleChange3 = withDebounce(studentHandler3, 300)

  return (
    <>
      <DevelopusInputText
        defaultValue={student1}
        onChange={debouncedHandleChange1}
        placeholder={placeholder1}
        label={placeholder1}
      />

      <DevelopusInputText
        defaultValue={student2}
        onChange={debouncedHandleChange2}
        placeholder={placeholder2}
        label={placeholder2}
      />

      <DevelopusInputText
        defaultValue={student3}
        onChange={debouncedHandleChange3}
        placeholder={placeholder3}
        label={placeholder3}
      />
    </>
  )
}

export default DevelopusInputTextTest
